import $ from 'jquery';
import pblWindow from '../../components/pblWindow.vue';
import { setImgsize } from '@/utils/utils';
var stageUrl = process.env.VUE_APP_IMG_URL;
export default {
  name: 'pbl',
  meta: {
    title: '瀑布流'
  },
  data() {
    return {
      list: [],
      singleform: {
        limit: 100,
        page: 1
      },
      total: 0,
      showWindow: false,
      modelData: {},
      config: {},
      stageUrl: '',
      screenName: '',
      detailUrl_p: '',
      detailUrl: '',
      detailCode: '',
      windowTop: 0,
      m_index: 0
    };
  },
  components: {
    pblWindow
  },
  methods: {
    // 获取页面配置
    getConfig() {
      this.singleform.deptId = this.$route.query.fid || '151066';
      this.singleform.formId = 215424;
      this.singleform.formUserId = this.$route.query.formUserId;
      this.$api.getListByUserId(this.singleform).then(res => {
        if (!res.formUserList || !res.formUserList.length) return;
        this.screenName = res.formUserList[0].formData.find(item => {
          return item.id == 3;
        }) ? res.formUserList[0].formData.find(item => {
          return item.id == 3;
        }).values[0].val : '';
        this.config = {
          formId_a: 112720,
          formId_3d: 113010,
          formId_column: 112712
        };
        this.getsingleformList();
      });
    },
    hideWindow() {
      this.showWindow = false;
    },
    // 获取文物列表
    getsingleformList() {
      this.singleform.deptId = this.$route.query.fid || '151066';
      this.singleform.fid = this.$route.query.fid || '151066';
      this.singleform.formId = this.config.formId_3d;
      // this.$api.singleformList(this.singleform).then((res) => {
      // })
      this.$api.singleadvanceSearch(this.singleform).then(res => {
        this.total = res.totalPage;
        this.setData(res.dataList);
        if (this.singleform.page < this.total) {
          this.singleform.page++;
          this.getsingleformList();
        }
      });
    },
    setData(data) {
      data = data.map((item, index) => {
        let nItem = {
          columnName: this.getValInFormData(item.formIdValueData, 'column'),
          name: this.getValInFormData(item.formIdValueData, 'antiqueName'),
          img: this.getValInFormData(item.formIdValueData, 'thumbnail', 'img'),
          code: this.getValInFormData(item.formIdValueData, 'autoId'),
          autoCode: this.getValInFormData(item.formIdValueData, 'autoCode'),
          // description: this.getValInFormData(item.formIdValueData, 'description'),
          // audio: this.getValInFormData(item.formIdValueData, 10, 'file'),
          type: this.getValInFormData(item.formIdValueData, 'type'),
          touchType: this.getValInFormDatas(item.formIdValueData, 'touchType'),
          index: index
          // zhuanti: this.getValInFormData(item.formData, 8)
        };
        return nItem;
      });
      // 手动塞重复数据的index
      data.map(item => {
        if (data.filter(l => {
          return l.code == item.code;
        }).length > 1) {
          let f_list = data.filter(l => {
            return l.code == item.code;
          });
          f_list.map((f, i) => {
            data[f.index].m_index = i;
          });
        }
      });
      data = data.filter(item => {
        return item.touchType.indexOf(this.screenName) > -1;
      });
      this.list = this.singleform.page === 1 ? data : this.list.concat(data);
      if (this.list.length < 40) {
        this.list = this.list.concat(this.list).concat(this.list);
      }
      if (this.singleform.page < this.total) return;
      this.$nextTick(() => {
        let list = ['books.js'];
        list.map(item => {
          let oScript = document.createElement('script');
          oScript.type = 'text/javascript';
          oScript.src = `js/${item}`;
          document.body.appendChild(oScript);
        });
        // kaishi()
        let that = this;
      });
    },
    clickItem(index) {
      this.modelData = this.list[index];
      this.detailCode = this.list[index].code;
      this.showWindow = true;
      this.detailUrl = this.detailUrl_p + this.detailCode + `${this.modelData.audoCode ? `&audoCode=${this.modelData.audoCode}` : ''}`;
    },
    getValInFormData(data, id, type, index) {
      index = index || 0;
      if (!data[id] || !data[id].groupValues[index] || !data[id].groupValues[index].values[0].length) {
        return '';
      }
      let target;
      if (type && type == 'img') {
        if (!data[id].groupValues[index].values[0][0]) return '';
        // target = process.env.NODE_ENV == 'development' ? (stageUrl + data[id].groupValues[index].values[0][0].name) : data[id].groupValues[index].values[0][0].fileUrl
        // target = process.env.NODE_ENV == 'development' ? (stageUrl + data[id].groupValues[index].values[0][0].name) : setImgsize(data[id].groupValues[index].values[0][0], 320, 420)
        // target = setImgsize(data[id].groupValues[index].values[0][0], 320, 420)
        target = data[id].groupValues[index].values[0][0].fileUrl;
      } else {
        target = type ? data[id].groupValues[index].values[0][0][type] : data[id].groupValues[index].values[0][0].val;
      }
      return target;
    },
    getValInFormDatas(data, id, type) {
      let target = data[id];
      if (!target) return '';
      target = target.groupValues[0];
      target = target.values[0].map(item => {
        return item.val;
      });
      return target.join(',');
    },
    getValInFormDataList(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      }).values;
      if (!target) return '';
      target = target.map(item => {
        return item.val;
      });
      return target.join(',');
    },
    changeWindowTop(data) {
      // this.windowTop = data
    }
  },
  mounted() {
    this.detailUrl_p = `${location.origin}${location.pathname}#/pblDetail?fid=${this.$route.query.fid}&code=`;
    // this.detailUrl_p = `https://museum.chaoxing.com/frontendTest1/wfw/#/pblDetail?fid=${this.$route.query.fid}&code=`
  },
  created() {
    this.stageUrl = process.env.VUE_APP_IMG_URL;
    let list1 = ['FBXLoader.js', 'inflate.min.js', 'TGALoader.js', 'TrackballControls.js', 'PDBLoader.js', 'CSS2DRenderer.js', 'OBJLoader.js', 'FBXLoader.js', 'MTLLoader.js', 'Detector.js'];
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
    list1.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/3d/${item}`;
      document.body.appendChild(oScript);
    });
    let list2 = ['jquery-1.11.0.min.js', 'heartcode-canvasloader-min.js', 'threesixty.js'];
    list2.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/360/${item}`;
      document.body.appendChild(oScript);
    });
    this.getConfig();
    let list = ['main.js', 'layer.js'];
    list.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/${item}`;
      document.body.appendChild(oScript);
    });
  },
  computed: {
    isMobile() {
      return this.$cookie.get('_isMobile');
    }
  }
};